// src/components/globe/FiltersPanel.js
import React, { useState } from "react";

const THEME_OPTIONS = [
  { key: "beaches", label: "Peaceful beaches" },
  { key: "mountains", label: "Mesmerizing mountains" },
  { key: "nightlife", label: "Vibrant nightlife" },
  { key: "culture", label: "Rich culture" },
  { key: "wildlife", label: "Amazing wildlife" },
  { key: "spiritual", label: "Spiritual retreats" },
  { key: "heritage", label: "Heritage wonders" },
  { key: "adventure", label: "Thrilling adventures" },
  { key: "food", label: "Delicious local food" },
  { key: "shopping", label: "Great shopping" }, // new
];

const FiltersPanel = ({
  filters,
  setFilters /* showHeatmap, setShowHeatmap (unused now) */,
}) => {
  const [open, setOpen] = useState(false);
  const update = (key, value) =>
    setFilters((prev) => ({ ...prev, [key]: value }));

  return (
    <div style={{ position: "relative", zIndex: 20 }}>
      {/* Toggle button */}
      <button
        onClick={() => setOpen((o) => !o)}
        style={{
          background: "rgba(18,18,24,0.95)",
          color: "white",
          border: "1px solid #2a2a35",
          borderRadius: 10,
          padding: "10px 16px",
          minWidth: 140,
          cursor: "pointer",
          boxShadow: "0 6px 16px rgba(0,0,0,0.25)",
        }}
      >
        Filters {open ? "▴" : "▾"}
      </button>

      {/* Collapsible content */}
      {open && (
        <div
          className="filter-dropdown"
          style={{
            marginTop: 8,
            position: "absolute", // ✅ ensures dropdown anchors correctly below button
            right: 0,
            background: "rgba(18,18,24,0.95)",
            color: "white",
            border: "1px solid #2a2a35",
            borderRadius: 12,
            padding: "10px 12px",
            width: 300,
            boxShadow: "0 10px 28px rgba(0,0,0,0.35)",
          }}
        >
          <div style={{ fontWeight: 600, marginBottom: 10, opacity: 0.95 }}>
            I want to go to places with
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "6px 12px",
              marginBottom: 12,
            }}
          >
            {THEME_OPTIONS.map((t) => (
              <label
                key={t.key}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  checked={filters.themes.includes(t.key)}
                  onChange={(e) => {
                    const next = e.target.checked
                      ? [...filters.themes, t.key]
                      : filters.themes.filter((k) => k !== t.key);
                    update("themes", next);
                  }}
                />
                <span>{t.label}</span>
              </label>
            ))}
          </div>

          {/* Budget (demo) */}
          <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 6 }}>
            Budget (demo)
          </div>
          <select
            value={filters.budget}
            onChange={(e) => update("budget", e.target.value)}
            style={{
              width: "100%",
              padding: 8,
              borderRadius: 8,
              border: "1px solid #3a3a48",
              background: "#121218",
              color: "white",
            }}
          >
            <option value="">Any</option>
            <option value="low">Budget</option>
            <option value="mid">Mid</option>
            <option value="high">Luxury</option>
          </select>

          {/* Popularity heatmap control removed */}
        </div>
      )}
    </div>
  );
};

export default FiltersPanel;
